<!-- faq section -->
<section id="faq" class="saas1 testimonial-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="faq-block">
                    <div>
                        <h3 class="frequent-text">Häufig gestellte Fragen (FAQ)</h3>
                        <h6>Erhalten Sie Antworten auf die wichtigsten Fragen rund um unsere Datenservices und wie diese Ihnen helfen können, Ihre B2B-Lead-Generierung und Geschäftsentwicklung optimal zu unterstützen.
                        </h6>
                        <div class="mb-5"></div>
                        <div class="card">
                            <div class="accordion faq" id="accordionExample">
                                <div ngbAccordion [closeOthers]="true">
                                    <ng-container *ngFor="let item of selectedItems;">
                                        <div
                                                ngbAccordionItem
                                                [collapsed]="item.question !== 'Do I need to make a payment?'"
                                                class="border-bottom pb-1 mb-1"
                                                [class.border-0]="last">
                                            <h2 ngbAccordionHeader>
                                                <button ngbAccordionButton>
                                                    <a>
                                                        <div class="fa fa-angle-right rotate me-2"></div>
                                                    </a>
                                                    {{ item.question }}
                                                </button>
                                            </h2>
                                            <div ngbAccordionCollapse>
                                                <div ngbAccordionBody>
                                                    <ng-template>
                                                        {{ item.answer }}
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                        <hr *ngIf="!last" class="my-0">
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="faq-img-block">
                    <img src="../../../../../assets/images/Own/faq-img.png" alt="faq-person" class="img-fluid">
                </div>
            </div>
        </div>
        <div class="mt-4">
            <span class="text-secondary">Haben Sie noch eine Frage?</span>
            <a href="mailto:kontakt@palladio-leads.de" class="ms-1 fw-medium link-primary text-decoration-underline">
                kontakt&#64;palladio-leads.de
            </a>
        </div>
        <div class="mt-5"></div>
    </div>
</section>
